import type React from "react";
import {memo} from "react";

import {Box} from "../ui/box";

type Props = {
    className?: string;
};

const Dot: React.FC<Props> = ({className}) => {
    return (
        <Box
            className={`w-1.5 
                h-1.5 
                border 
                border-solid 
                border-white 
                rounded-full 
                ${className}
            `}
        />
    );
};

export default memo(Dot);
